// Initial Setup of connection to API
import React, { useEffect, useState } from 'react';
import { loadStripeTerminal } from '@stripe/terminal-js';

import TerminalContext from 'app/context/TerminalContext';
import useApi from 'app/context/useApi';

let StripeTerminal = null;

export default function TerminalProvider(props) {

    const api = useApi();

    const [ terminal, setTerminal ] = useState(null);

    const fetchConnectionToken = () => {
        // Do not cache or hardcode the ConnectionToken. The SDK manages the ConnectionToken's lifecycle.
        return api.get('/admin/accounting/terminal/token')
            .then((res) => {
                console.log(res);
                return res.connectionToken.secret;
            });
    }

    const unexpectedDisconnect = () => {
        // In this function, your app should notify the user that the reader disconnected.
        // You can also include a way to attempt to reconnect to a reader.
        console.log("Disconnected from reader")
    }

    async function loadTerminal(callback) {
        StripeTerminal = await loadStripeTerminal();

        const newTerminal = StripeTerminal.create({
            onFetchConnectionToken: fetchConnectionToken,
            onUnexpectedReaderDisconnect: unexpectedDisconnect,
        });

        setTerminal(newTerminal);

        if (callback) callback();
    }

    return (
        <TerminalContext.Provider value={{terminal, loadTerminal }}>
            {props.children}
        </TerminalContext.Provider>
    )
}
